/**
 * CloseIcon component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number | string} [props.size] - The size of the icon. Defaults to 20.
 * @param {string} [props.color] - The color of the icon. Defaults to "#545454".
 * @param {string} [props.className] - The additional styling.
 * @param {any} [props.onClick] - The function to call when the icon is clicked.
 * @returns {JSX.Element} - The CloseIcon component.
 */
const CloseIcon = ({ size, color, className, onClick }) => {
  return (
    <svg
      width={size ?? "20"}
      height={size ?? "20"}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ?? ""}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.29289 4.79289C4.68342 4.40237 5.31658 4.40237 5.70711 4.79289L10 9.08579L14.2929 4.79289C14.6834 4.40237 15.3166 4.40237 15.7071 4.79289C16.0976 5.18342 16.0976 5.81658 15.7071 6.20711L11.4142 10.5L15.7071 14.7929C16.0976 15.1834 16.0976 15.8166 15.7071 16.2071C15.3166 16.5976 14.6834 16.5976 14.2929 16.2071L10 11.9142L5.70711 16.2071C5.31658 16.5976 4.68342 16.5976 4.29289 16.2071C3.90237 15.8166 3.90237 15.1834 4.29289 14.7929L8.58579 10.5L4.29289 6.20711C3.90237 5.81658 3.90237 5.18342 4.29289 4.79289Z"
        fill={color ?? "#545454"}
      />
    </svg>
  );
};

export default CloseIcon;
